<aside class="dashboard-sidebar"
       [class.dashboard-sidebar--open]="mobileOpen"
       [class.dashboard-sidebar--collapsed]="collapsed">
  <a routerLink="/"
     class="sidebar-brand"
     [attr.aria-label]="'sidebar.home' | translate"
     (click)="onNavClick()"
     nz-tooltip
     [nzTooltipTitle]="collapsed ? ('sidebar.home' | translate) : ''"
     nzTooltipPlacement="right">
    <img src="assets/icon/logo-sso.png" alt="Cổng xác thực tập trung" class="sidebar-brand__logo">
    <div class="sidebar-brand__text">
      <strong>Cổng xác thực tập trung</strong>
      <span>Single Sign-On</span>
    </div>
  </a>

  <button type="button"
          class="sidebar-collapse-btn"
          (click)="toggleCollapsed()"
          [attr.aria-label]="collapsed ? ('sidebar.expandMenu' | translate) : ('sidebar.collapseMenu' | translate)"
          [attr.aria-expanded]="!collapsed"
          nz-tooltip
          [nzTooltipTitle]="collapsed ? ('sidebar.expandMenu' | translate) : ('sidebar.collapseMenu' | translate)"
          nzTooltipPlacement="right">
    <span class="sidebar-collapse-btn__icon"></span>
  </button>

  <nav class="sidebar-nav">
    <a routerLink="/"
       routerLinkActive="sidebar-link--active"
       [routerLinkActiveOptions]="exactRouterLinkActiveOptions"
       class="sidebar-link sidebar-link--home"
       (click)="onNavClick()"
       nz-tooltip
       [nzTooltipTitle]="collapsed ? ('sidebar.home' | translate) : ''"
       nzTooltipPlacement="right">
      <span class="sidebar-link__icon sidebar-link__icon--home"></span>
      <span class="sidebar-link__label">{{ 'sidebar.home' | translate }}</span>
    </a>

    <a routerLink="/announcements"
       routerLinkActive="sidebar-link--active"
       [routerLinkActiveOptions]="exactRouterLinkActiveOptions"
       class="sidebar-link"
       (click)="onNavClick()"
       nz-tooltip
       [nzTooltipTitle]="collapsed ? ('sidebar.notifications' | translate) : ''"
       nzTooltipPlacement="right">
      <span class="sidebar-link__icon sidebar-link__icon--notifications"></span>
      <span class="sidebar-link__label">{{ 'sidebar.notifications' | translate }}</span>
    </a>

    <a routerLink="/my-systems"
       routerLinkActive="sidebar-link--active"
       class="sidebar-link"
       (click)="onNavClick()"
       nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.mySystems' | translate) : ''" nzTooltipPlacement="right">
      <span class="sidebar-link__icon sidebar-link__icon--systems"></span>
      <span class="sidebar-link__label">{{ 'sidebar.mySystems' | translate }}</span>
    </a>

    <div class="sidebar-section sidebar-section--account">
      <div class="sidebar-section__title">{{ 'sidebar.accountCategory' | translate }}</div>
      <a href="#" class="sidebar-link" (click)="onOpenMyAccounts($event)"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.myAccounts' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--account"></span>
        <span class="sidebar-link__label">{{ 'sidebar.myAccounts' | translate }}</span>
      </a>
      <a routerLink="/change-password" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.changePassword' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--password"></span>
        <span class="sidebar-link__label">{{ 'sidebar.changePassword' | translate }}</span>
      </a>
    </div>

    <div class="sidebar-section">
      <div class="sidebar-section__title">{{ 'sidebar.support' | translate }}</div>
      <a routerLink="/asked-questions"
         routerLinkActive="sidebar-link--active"
         [routerLinkActiveOptions]="exactRouterLinkActiveOptions"
         class="sidebar-link"
         (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.faq' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--faq"></span>
        <span class="sidebar-link__label">{{ 'sidebar.faq' | translate }}</span>
      </a>
      <a routerLink="/usage-guide"
         routerLinkActive="sidebar-link--active"
         [routerLinkActiveOptions]="exactRouterLinkActiveOptions"
         class="sidebar-link"
         (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.usageGuide' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--guide"></span>
        <span class="sidebar-link__label">{{ 'sidebar.usageGuide' | translate }}</span>
      </a>
      <a href="#" class="sidebar-link" (click)="onOpenSupportContact($event)"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.supportContact' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--support"></span>
        <span class="sidebar-link__label">{{ 'sidebar.supportContact' | translate }}</span>
      </a>
    </div>

    <div class="sidebar-section" *ngIf="isStudentManager && !isAdmin">
      <div class="sidebar-section__title">{{ 'sidebar.studentManagerCategory' | translate }}</div>
      <a routerLink="/users" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.studentManagement' | translate) : ''" nzTooltipPlacement="right">
        <i class="fas fa-user-graduate sidebar-link__icon-fa"></i>
        <span class="sidebar-link__label">{{ 'sidebar.studentManagement' | translate }}</span>
      </a>
    </div>

    <div class="sidebar-section" *ngIf="isAdmin">
      <div class="sidebar-section__title">{{ 'sidebar.admin' | translate }}</div>
      <a routerLink="/users" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.userManagement' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--users"></span>
        <span class="sidebar-link__label">{{ 'sidebar.userManagement' | translate }}</span>
      </a>
      <a routerLink="/projects" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.appManagement' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--apps"></span>
        <span class="sidebar-link__label">{{ 'sidebar.appManagement' | translate }}</span>
      </a>

      <a routerLink="/notifications" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.notificationManagement' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--notifications"></span>
        <span class="sidebar-link__label">{{ 'sidebar.notificationManagement' | translate }}</span>
      </a>
      <a routerLink="/asked-questions/admin" routerLinkActive="sidebar-link--active" [routerLinkActiveOptions]="exactRouterLinkActiveOptions" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.faqManagement' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--faq"></span>
        <span class="sidebar-link__label">{{ 'sidebar.faqManagement' | translate }}</span>
      </a>
      <a routerLink="/audit-logs" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.auditLogs' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--history"></span>
        <span class="sidebar-link__label">{{ 'sidebar.auditLogs' | translate }}</span>
      </a>
      <a routerLink="/system-admin" routerLinkActive="sidebar-link--active"
         [routerLinkActiveOptions]="{ exact: true }" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.caching' | translate) : ''" nzTooltipPlacement="right">
        <span class="sidebar-link__icon sidebar-link__icon--caching"></span>
        <span class="sidebar-link__label">{{ 'sidebar.caching' | translate }}</span>
      </a>
      <a routerLink="/system-admin/recovery-requests" routerLinkActive="sidebar-link--active" class="sidebar-link" (click)="onNavClick()"
         nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.recoveryRequests' | translate) : ''" nzTooltipPlacement="right">
        <i class="fas fa-user-shield sidebar-link__icon-fa"></i>
        <span class="sidebar-link__label">{{ 'sidebar.recoveryRequests' | translate }}</span>
      </a>
    </div>
  </nav>

  <div class="sidebar-footer">
    <button type="button" class="sidebar-logout" (click)="onLogout()"
            nz-tooltip [nzTooltipTitle]="collapsed ? ('sidebar.logout' | translate) : ''" nzTooltipPlacement="right">
      <span class="sidebar-logout__icon"></span>
      <span class="sidebar-logout__label">{{ 'sidebar.logout' | translate }}</span>
    </button>
  </div>
</aside>
